import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '../store'
//import {getToken} from '@/utils/auth'
//import {outLogin} from '../api/login'
// var root = process.env.BASE_API
// 创建axios实例
const service = axios.create({
  baseURL: '/manager', // api的base_url
  timeout: 35000, // 请求超时时间
  headers:{
    'Account':localStorage.getItem("accountnumber"),
    'Authorization':'Bearer '+localStorage.getItem("authorization"),
  },
});


// request拦截器
// service.interceptors.request.use(config => {
//   // if (store.getters.token) {
//   //   config.headers['Authorization'] = getToken();  // 让每个请求携带自定义token 请根据实际情况自行修改
//   // }
//   config.url=root+config.url
//   //console.log(config.url)
//   return config
// }, error => {
//   // Do something with request error
//   //console.log(error) // for debug
//   // Promise.reject(error)
// })

// respone拦截器
let count = 0;
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 200) {
      // 401:未登录;
      if (res.code === 600) {
        if(count==0){
          MessageBox.confirm('该用户访问超时，请重新登录', '访问超时提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
                store.dispatch('FedLogOut').then(() => {
                  localStorage.removeItem('authorization');
                  location.reload()// 为了重新实例化vue-router对象 避免bug

            })
          }).catch(()=>{
            count=0;
          })
        }
        ++count;
      }else if(res.code===400){
        MessageBox.alert(res.message,'提示',{
          confirmButtonText:'好的',
          type:'error'
        })
        return response;
      }
      else if(res.code===405){
        MessageBox.alert('操作过于频繁，请稍后操作','提示',{
          confirmButtonText:'好的',
          type:'error'
        })
        return response;
      }
      // return Promise.reject('error')
    } else {
      return response;
    }
  },
  error => {
    //console.log(error);
    //console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js